import React, { useState } from 'react';
import './index.css';
import { Button, Form } from 'react-bootstrap';
import { HashLoader } from 'react-spinners';
import ConfettiExplosion from 'react-confetti-explosion';
import { IoCheckmarkCircleSharp } from 'react-icons/io5';
import StatesCities from '../../../assets/json/states-and-districts.json';

function RegistrationForm({ isCompleted, isLoading, regData, setRegData, handleRegistrationData }) {

  const [wizIndex, setWizIndex] = useState(1);
  const [inputError, setInputError] = useState();
  const [cityList, setCityList] = useState(null);

  function handleWizardNext(value) {
    const { businessName, state } = regData;

    if (value === 1) {
      setWizIndex(2);
    } else if (value === 2) {
      if (!businessName) {
        setInputError({ ...inputError, businessName: 'This field is required.' });
      } else {
        setWizIndex(3);
      }
    } else if (value === 3) {
      if (!state) {
        setInputError({ ...inputError, state: 'This field is required.' });
      } else {
        setWizIndex(4);
      }
    } else if (value === 4) {
      setWizIndex(5);
    }
  }

  function handleWizardBack(value) {
    if (value === 2) {
      setWizIndex(1);
    } else if (value === 3) {
      setWizIndex(2);
    } else if (value === 4) {
      setWizIndex(3);
    } else if (value === 5) {
      setWizIndex(4);
    }
  }

  function getStateCities(state) {
    const filteredCitiesByState = StatesCities && StatesCities.find(val => val.state === state).districts;

    if (filteredCitiesByState) {
      setCityList(filteredCitiesByState);
    }
  }

  function handleParseData() {
    const { phoneNumber, email } = regData;

    if (!phoneNumber) {
      setInputError({ ...inputError, phoneNumber: 'This field is required.' });
    } else if (!email) {
      setInputError({ ...inputError, email: 'This field is required.' });
    } else {
      handleRegistrationData();
    }
  }

  if (isLoading) {
    return (
      <div className='h-100 position-relative'>
        {
          isCompleted ?
            <div className='h-100 d-flex align-items-center justify-content-center'>
              <div className='text-center'>
                <div className='mb-3'>
                  <div className='w-100 d-flex align-items-center justify-content-center'>
                    <ConfettiExplosion width={1800} />
                  </div>
                  <IoCheckmarkCircleSharp color='var(--bs-success)' size={80} />
                </div>
                <h3>You're Ready!</h3>
                <div className='mt-0 d-flex align-items-center justify-content-center'>
                  <p className='mb-0'>Your profile is ready, let's go to </p>
                  <Button
                    variant='link'
                    onClick={() => window.location.reload()}
                    className='px-0 ps-1'
                  >
                    Dashboard
                  </Button>
                </div>
              </div>
            </div>
            :
            <div className='h-100 d-flex align-items-center justify-content-center'>
              <div className='text-center'>
                <div className='d-flex align-items-center justify-content-center'>
                  <HashLoader color="#5E72E4" />
                </div>
                <h3 className='mt-5 fw-600'>Getting Ready!</h3>
                <p className='text-muted'>Creating your business profile and preparing your dashboard</p>
              </div>
            </div>
        }
      </div>
    )
  } else {
    return (
      <div className='row h-100'>
        <div className='col-3 h-100'>
          <div className='bg-light rounded-start h-100 pt-3 pb-5 ps-0 pe-3'>
            <div className='wiz-header mb-4'>
              {/* <Image src={logo} alt='logo-image' className='img-fluid' /> */}
              <h2 className='px-4 fw-bold'>Next2Estate</h2>
            </div>
            <div className={wizIndex === 1 ? 'py-3 mb-2 d-flex align-items-center text-primary' : 'py-3 mb-2 d-flex align-items-center'}>
              <div className={wizIndex === 1 ? 'wiz-nav-active me-2' : 'wiz-nav-line me-2'} />
              <h6 className='mb-0 fw-600'>Get Started</h6>
            </div>
            <div className={wizIndex === 2 ? 'py-3 mb-2 d-flex align-items-center text-primary' : wizIndex <= 1 ? 'py-3 mb-2 d-flex align-items-center wiz-nav-text' : 'py-3 mb-2 d-flex align-items-center'}>
              <div className={wizIndex === 2 ? 'wiz-nav-active me-2' : 'wiz-nav-line me-2'} />
              <h6 className='mb-0 fw-600'>Business Name</h6>
            </div>
            <div className={wizIndex === 3 ? 'py-3 mb-2 d-flex align-items-center text-primary' : wizIndex <= 2 ? 'py-3 mb-2 d-flex align-items-center wiz-nav-text' : 'py-3 mb-2 d-flex align-items-center'}>
              <div className={wizIndex === 3 ? 'wiz-nav-active me-2' : 'wiz-nav-line me-2'} />
              <h6 className='mb-0 fw-600'>Business Address</h6>
            </div>
            <div className={wizIndex === 4 ? 'py-3 mb-2 d-flex align-items-center text-primary' : wizIndex <= 3 ? 'py-3 mb-2 d-flex align-items-center wiz-nav-text' : 'py-3 mb-2 d-flex align-items-center'}>
              <div className={wizIndex === 4 ? 'wiz-nav-active me-2' : 'wiz-nav-line me-2'} />
              <h6 className='mb-0 fw-600'>Legal Details</h6>
            </div>
            <div className={wizIndex === 5 ? 'py-3 mb-2 d-flex align-items-center text-primary' : wizIndex <= 4 ? 'py-3 mb-2 d-flex align-items-center wiz-nav-text' : 'py-3 mb-2 d-flex align-items-center'}>
              <div className={wizIndex === 5 ? 'wiz-nav-active me-2' : 'wiz-nav-line me-2'} />
              <h6 className='mb-0 fw-600'>Contact Details</h6>
            </div>
          </div>
        </div>
        <div className='col-9 h-100'>
          <div className='h-100 position-relative bg-white rounded-end p-5 ps-4 pt-4'>
            {
              wizIndex === 1 ?
                <div className='row h-100 align-items-center justify-content-center text-center'>
                  <div className='col-md-12 col-12'>
                    <h1 className='text-uppercase'>Let's <b>get started</b></h1>
                    <h5 className='mb-5 text-uppercase'>Setup your profile details</h5>
                  </div>
                  <div className='col-md-12 col-12 d-flex align-items-center justify-content-center'>
                    <Button
                      variant='primary'
                      className='px-4 py-2'
                      onClick={() => handleWizardNext(wizIndex)}
                    >
                      <span className='px-3 py-1'>Get Started</span>
                    </Button>
                  </div>
                </div>
                : wizIndex === 2 ?
                  <div className='row'>
                    <h3 className='mb-5'>Business Name</h3>
                    <div className='col-md-12 col-12'>
                      <Form.Group controlId="businessName">
                        <Form.Label>Name of the Business</Form.Label>
                        <Form.Control
                          size='lg'
                          placeholder='Enter business name'
                          onChange={(e) => {
                            const { id, value } = e.target;
                            setInputError({ ...inputError, [id]: '' });
                            setRegData((prevData) => {
                              return { ...prevData, [id]: value.toUpperCase() };
                            });
                          }}
                          className={inputError && inputError.businessName ? 'border-0 border-bottom rounded-0 px-0 border-danger text-capitalize' : 'border-0 border-bottom rounded-0 px-0 text-capitalize'}
                          value={regData.businessName}
                          isInvalid={inputError && inputError.businessName}
                        />
                        <Form.Control.Feedback type="invalid">{inputError && inputError.businessName}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                  </div>
                  :
                  wizIndex === 3 ?
                    <div className='row'>
                      <h3 className='mb-5'>Business Address</h3>
                      <div className='col-md-6 col-12'>
                        <Form.Group controlId="address">
                          <Form.Label>Address</Form.Label>
                          <Form.Control
                            size='lg'
                            placeholder='Enter address'
                            onChange={(e) => {
                              const { id, value } = e.target;
                              setInputError({ ...inputError, [id]: '' });
                              setRegData((prevData) => {
                                return { ...prevData, [id]: value };
                              });
                            }}
                            className='border-0 border-bottom rounded-0 px-0 text-capitalize'
                            value={regData.address}
                          />
                        </Form.Group>
                      </div>
                      <div className='col-md-6 col-12'>
                        <Form.Group controlId="state">
                          <Form.Label>State *</Form.Label>
                          <Form.Select
                            size='lg'
                            className={inputError && inputError.state ? 'border-0 border-bottom rounded-0 px-0 border-danger bg-white' : 'border-0 border-bottom rounded-0 px-0 bg-white'}
                            onChange={(e) => {
                              const { id, value } = e.target;
                              setInputError({ ...inputError, [id]: '' });
                              setRegData((prevData) => {
                                return { ...prevData, [id]: value };
                              });
                              getStateCities(value);
                            }}
                            value={regData.state}
                            isInvalid={inputError && inputError.state}
                          >
                            <option>Select</option>
                            {
                              StatesCities && StatesCities.map((item, index) => {
                                return (
                                  <option key={index} value={item.state}>{item.state}</option>
                                )
                              })
                            }
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">{inputError && inputError.state}</Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className='col-md-6 col-12'>
                        <Form.Group className='mt-3' controlId="pincode">
                          <Form.Label>Pincode</Form.Label>
                          <Form.Control
                            size='lg'
                            maxLength={6}
                            placeholder='Enter pincode'
                            className={inputError && inputError.pincode ? 'border-0 border-bottom rounded-0 px-0 border-danger' : 'border-0 border-bottom rounded-0 px-0'}
                            onChange={(e) => {
                              const { id, value } = e.target;
                              const regEx = /^[0-9\b]+$/;
                              if (value === '' || regEx.test(value)) {
                                setInputError({ ...inputError, [id]: '' });
                                setRegData((prevData) => {
                                  return { ...prevData, [id]: value };
                                });
                              }
                            }}
                            value={regData.pincode}
                            isInvalid={inputError && inputError.pincode}
                          />
                          <Form.Control.Feedback type="invalid">{inputError && inputError.pincode}</Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className='col-md-6 col-12'>
                        <Form.Group className='mt-3' controlId="city">
                          <Form.Label>City</Form.Label>
                          <Form.Select
                            size='lg'
                            placeholder='Enter city'
                            className={inputError && inputError.city ? 'border-0 border-bottom rounded-0 px-0 border-danger bg-white' : 'border-0 border-bottom rounded-0 px-0 bg-white'}
                            onChange={(e) => {
                              const { id, value } = e.target;
                              setInputError({ ...inputError, [id]: '' });
                              setRegData((prevData) => {
                                return { ...prevData, [id]: value };
                              });
                            }}
                            value={regData.city}
                            isInvalid={inputError && inputError.city}
                          >
                            <option>Select</option>
                            {
                              cityList && cityList.map((item, index) => {
                                return (
                                  <option key={index} value={item}>{item}</option>
                                )
                              })
                            }
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">{inputError && inputError.city}</Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>
                    :
                    wizIndex === 4 ?
                      <div className='row'>
                        <h3 className='mb-5'>Legal Details</h3>
                        <div className='col-md-6 col-12'>
                          <Form.Group controlId="cin">
                            <Form.Label>CIN</Form.Label>
                            <Form.Control
                              size='lg'
                              maxLength={21}
                              className='border-0 border-bottom rounded-0 px-0'
                              placeholder='Enter CIN'
                              onChange={(e) => {
                                const { id, value } = e.target;
                                setInputError({ ...inputError, [id]: '' });
                                setRegData((prevData) => {
                                  return { ...prevData, [id]: value.toUpperCase() };
                                });
                              }}
                              value={regData.cin}
                            />
                          </Form.Group>
                        </div>
                        <div className='col-md-6 col-12'>
                          <Form.Group controlId="pan">
                            <Form.Label>PAN</Form.Label>
                            <Form.Control
                              size='lg'
                              maxLength={10}
                              className='border-0 border-bottom rounded-0 px-0'
                              placeholder='Enter PAN'
                              onChange={(e) => {
                                const { id, value } = e.target;
                                setInputError({ ...inputError, [id]: '' });
                                setRegData((prevData) => {
                                  return { ...prevData, [id]: value.toUpperCase() };
                                });
                              }}
                              value={regData.pan}
                            />
                          </Form.Group>
                        </div>
                        <div className='col-md-6 col-12'>
                          <Form.Group className='mt-3' controlId="gst">
                            <Form.Label>GST</Form.Label>
                            <Form.Control
                              size='lg'
                              maxLength={15}
                              className='border-0 border-bottom rounded-0 px-0'
                              placeholder='Enter GST'
                              onChange={(e) => {
                                const { id, value } = e.target;
                                setInputError({ ...inputError, [id]: '' });
                                setRegData((prevData) => {
                                  return { ...prevData, [id]: value.toUpperCase() };
                                });
                              }}
                              value={regData.gst}
                            />
                          </Form.Group>
                        </div>
                        <div className='col-md-6 col-12'>
                          <Form.Group className='mt-3' controlId="rera">
                            <Form.Label>RERA (Reg. No.)</Form.Label>
                            <Form.Control
                              size='lg'
                              className='border-0 border-bottom rounded-0 px-0'
                              placeholder='Enter RERA reg. no.'
                              onChange={(e) => {
                                const { id, value } = e.target;
                                setInputError({ ...inputError, [id]: '' });
                                setRegData((prevData) => {
                                  return { ...prevData, [id]: value.toUpperCase() };
                                });
                              }}
                              value={regData.rera}
                            />
                          </Form.Group>
                        </div>
                      </div>
                      :
                      <div className='row'>
                        <h3 className='mb-5'>Contact Details</h3>
                        <div className='col-md-6 col-12'>
                          <Form.Group controlId="phoneNumber">
                            <Form.Label>Phone Number *</Form.Label>
                            <Form.Control
                              size='lg'
                              maxLength={10}
                              placeholder='Enter 10 digit phone number'
                              className={inputError && inputError.phoneNumber ? 'border-0 border-bottom rounded-0 px-0 border-danger' : 'border-0 border-bottom rounded-0 px-0'}
                              onChange={(e) => {
                                const { id, value } = e.target;
                                const regEx = /^[0-9\b]+$/;
                                if (value === '' || regEx.test(value)) {
                                  setInputError({ ...inputError, [id]: '' });
                                  setRegData((prevData) => {
                                    return { ...prevData, [id]: value };
                                  });
                                }
                              }}
                              value={regData.phoneNumber}
                              isInvalid={inputError && inputError.phoneNumber}
                            />
                            <Form.Control.Feedback type="invalid">{inputError && inputError.phoneNumber}</Form.Control.Feedback>
                          </Form.Group>
                        </div>
                        <div className='col-md-6 col-12'>
                          <Form.Group controlId="alternateNumber">
                            <Form.Label>Alternate Number</Form.Label>
                            <Form.Control
                              size='lg'
                              maxLength={10}
                              className='border-0 border-bottom rounded-0 px-0'
                              placeholder='Enter 10 digit alternate number'
                              onChange={(e) => {
                                const { id, value } = e.target;
                                const regEx = /^[0-9\b]+$/;
                                if (value === '' || regEx.test(value)) {
                                  setInputError({ ...inputError, [id]: '' });
                                  setRegData((prevData) => {
                                    return { ...prevData, [id]: value };
                                  });
                                }
                              }}
                              value={regData.alternateNumber}
                            />
                          </Form.Group>
                        </div>
                        <div className='col-md-6 col-12'>
                          <Form.Group className='mt-3' controlId="email">
                            <Form.Label>Email *</Form.Label>
                            <Form.Control
                              size='lg'
                              type='email'
                              placeholder='user@example.com'
                              className={inputError && inputError.email ? 'border-0 border-bottom rounded-0 px-0 border-danger' : 'border-0 border-bottom rounded-0 px-0'}
                              onChange={(e) => {
                                const { id, value } = e.target;
                                setInputError({ ...inputError, [id]: '' });
                                setRegData((prevData) => {
                                  return { ...prevData, [id]: value };
                                });
                              }}
                              value={regData.email}
                              isInvalid={inputError && inputError.email}
                            />
                            <Form.Control.Feedback type="invalid">{inputError && inputError.email}</Form.Control.Feedback>
                          </Form.Group>
                        </div>
                        <div className='col-md-6 col-12'>
                          <Form.Group className='mt-3' controlId="website">
                            <Form.Label>Website</Form.Label>
                            <Form.Control
                              size='lg'
                              className='border-0 border-bottom rounded-0 px-0'
                              placeholder='https://www.example.com'
                              onChange={(e) => {
                                const { id, value } = e.target;
                                setInputError({ ...inputError, [id]: '' });
                                setRegData((prevData) => {
                                  return { ...prevData, [id]: value };
                                });
                              }}
                              value={regData.website}
                            />
                          </Form.Group>
                        </div>
                      </div>
            }
            <div className='position-absolute bottom-0 start-0 end-0 d-flex align-items-center justify-content-between p-5 pt-0'>
              {
                wizIndex !== 1 && wizIndex !== 2 ?
                  <Button
                    variant='light'
                    className='px-3 py-1'
                    onClick={() => handleWizardBack(wizIndex)}
                  >
                    Previous
                  </Button>
                  :
                  <div />
              }
              {
                wizIndex !== 5 && wizIndex !== 1 ?
                  <Button
                    variant='primary'
                    className='px-4 py-2'
                    onClick={() => handleWizardNext(wizIndex)}
                  >
                    <span className='px-3 py-1'>Continue</span>
                  </Button>
                  : wizIndex === 5 ?
                    <Button
                      variant='primary'
                      className='px-4 py-2'
                      onClick={handleParseData}
                    >
                      <span className='px-4 py-1'>Finish</span>
                    </Button>
                    :
                    null
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RegistrationForm;
